import type { Dict } from './ca.ts';

export const es: Dict = {
  langName: "Castellano",
  meta: {
    locale: "es_ES",
    siteName: "NetSereno PDF",
    homeTitle: "Herramientas PDF gratis y privadas, sin subir archivos | NetSereno PDF",
    homeDescription:
      "Une, divide, comprime, convierte, firma y protege PDF directamente en el navegador. Gratis, sin registro y sin enviar tus documentos a ningún servidor.",
    toolTitleSuffix: "| NetSereno PDF",
    noscript: "Esta aplicación necesita JavaScript para procesar los PDF en tu dispositivo.",
    chooseLanguage: "Elige el idioma",
  },
  nav: {
    skip: "Saltar al contenido",
    home: "Inicio",
    tools: "Herramientas",
    allTools: "Todas las herramientas",
    privacy: "Privacidad",
    language: "Idioma",
    themeLight: "Tema claro",
    themeDark: "Tema oscuro",
    menu: "Menú",
    resources: "Más recursos",
    netsereno: "Visita NetSereno",
  },
  categories: {
    organize: "Organizar",
    optimize: "Optimizar",
    convertTo: "Convertir a PDF",
    convertFrom: "Convertir desde PDF",
    edit: "Editar",
    security: "Seguridad y privacidad",
  },
  home: {
    badge: "100 % en tu dispositivo · sin subir nada",
    heroTitle: "Las herramientas PDF de siempre, sin enviar tus documentos a ninguna parte",
    heroSubtitle:
      "Une, divide, comprime, convierte y firma PDF directamente en el navegador. Gratis, sin registro y sin límites. Los archivos nunca salen de tu ordenador.",
    ctaPrimary: "Empieza ahora",
    ctaSecondary: "¿Por qué es privado?",
    searchLabel: "Busca una herramienta",
    searchPlaceholder: "Busca: unir, comprimir, firmar…",
    noResults: "Ninguna herramienta coincide con la búsqueda.",
    popular: "Popular",
    trust: [
      { title: "Sin subidas", text: "El procesamiento se hace con WebAssembly en tu navegador. Ningún archivo viaja por Internet." },
      { title: "Funciona sin conexión", text: "Después de la primera visita, puedes desconectarte y seguir trabajando." },
      { title: "Sin registro ni límites", text: "Sin cuentas, sin correos, sin marcas de agua y sin límites de tamaño artificiales." },
      { title: "En catalán, castellano y gallego", text: "Una alternativa local y transparente a los servicios extranjeros en línea." },
    ],
    howTitle: "Cómo funciona",
    howSteps: [
      { title: "Abre la herramienta", text: "El navegador descarga la aplicación (como cualquier web) y la guarda para usarla sin conexión." },
      { title: "Añade los archivos", text: "Los documentos se leen en la memoria de tu dispositivo. No se suben a ningún servidor." },
      { title: "Descarga el resultado", text: "El PDF resultante se genera en tu equipo. Al cerrar la pestaña, no queda ningún rastro." },
    ],
    whyTitle: "¿Por qué es importante?",
    whyText:
      "Cada día se suben miles de documentos sensibles (informes médicos, nóminas, contratos, DNI) a webs gratuitas alojadas fuera de la UE. Aunque prometan borrarlos, pierdes el control sobre quién accede a ellos. Con NetSereno PDF, el documento nunca sale de tu dispositivo: es la forma más sencilla de cumplir el RGPD cuando trabajas con PDF.",
    faqTitle: "Preguntas frecuentes",
    faq: [
      {
        q: "¿De verdad mis archivos no se suben?",
        a: "Sí. Todo el código se ejecuta en tu navegador. Puedes comprobarlo abriendo las herramientas de desarrollo (pestaña Red) o activando el modo avión: las herramientas siguen funcionando. Además, la política de seguridad del sitio (CSP) impide técnicamente enviar datos a otros servidores.",
      },
      {
        q: "¿Es gratis? ¿Dónde está el truco?",
        a: "Es un recurso gratuito de NetSereno, una empresa de ciberseguridad. No hay publicidad ni venta de datos: queremos demostrar que privacidad y comodidad son compatibles.",
      },
      {
        q: "¿Hay límite de tamaño o de número de archivos?",
        a: "No hay límites artificiales. El único límite es la memoria de tu dispositivo: en ordenadores normales se pueden procesar documentos de cientos de páginas.",
      },
      {
        q: "¿Puedo usarlo en el trabajo sin instalar nada?",
        a: "Sí. Solo necesitas un navegador moderno (Chrome, Edge, Firefox o Safari). También puedes «instalarla» como aplicación desde el navegador para abrirla sin conexión.",
      },
      {
        q: "¿La firma tiene validez legal?",
        a: "La herramienta Firmar PDF añade una firma manuscrita (imagen). No sustituye a una firma electrónica cualificada con certificado digital (DNIe, FNMT, Cl@ve).",
      },
    ],
    ctaTitle: "Tus PDF ya son privados. ¿Y el resto de tu empresa?",
    ctaText:
      "NetSereno vigila si los datos de tu organización circulan por la dark web, analiza vulnerabilidades de tu web y entrena a tu equipo contra el phishing.",
    ctaButton: "Descubre NetSereno",
    ctaResources: "Más recursos gratuitos",
    ctaEyebrow: "Ciberseguridad para organizaciones",
    toolsEyebrow: "Herramientas gratuitas y privadas",
  },
  common: {
    selectFiles: "Selecciona archivos",
    selectFile: "Selecciona un archivo",
    dropHere: "o arrástralos aquí",
    dropHereOne: "o arrástralo aquí",
    dropActive: "Suelta los archivos para añadirlos",
    pasteHint: "También puedes pegar archivos con Ctrl+V.",
    accepted: "Formatos: {formats}",
    localNotice: "Los archivos se procesan en este dispositivo y no se suben a ninguna parte.",
    addMore: "Añadir más archivos",
    remove: "Eliminar",
    moveUp: "Subir",
    moveDown: "Bajar",
    moveLeft: "Mover a la izquierda",
    moveRight: "Mover a la derecha",
    sortByName: "Ordenar por nombre",
    startOver: "Volver a empezar",
    processing: "Procesando…",
    loading: "Cargando…",
    rendering: "Generando miniaturas…",
    done: "¡Hecho!",
    download: "Descargar",
    downloadAll: "Descargar todo (ZIP)",
    continueWith: "Continuar con otra herramienta",
    continueWithLabel: "Usar el resultado en…",
    cancel: "Cancelar",
    close: "Cerrar",
    ok: "Aceptar",
    options: "Opciones",
    files: "Archivos",
    pageN: "Página {n}",
    pagesCount: "{n} páginas",
    pageCountOne: "1 página",
    selectAll: "Seleccionar todas",
    selectNone: "No seleccionar ninguna",
    invertSelection: "Invertir selección",
    selectedCount: "{n} de {total} seleccionadas",
    pageRange: "Páginas",
    pageRangeHint: "Ej.: 1-3, 5, 8- (vacío = todas)",
    pageRangeSelectHint: "Haz clic en las miniaturas o escribe un intervalo.",
    allPages: "Todas las páginas",
    customPages: "Páginas concretas",
    fileTooBig: "«{name}» ocupa {size}. En dispositivos con poca memoria puede fallar.",
    unsupported: "«{name}» no es un formato compatible con esta herramienta.",
    onlyOne: "Esta herramienta trabaja con un solo archivo. Se ha usado «{name}».",
    minFiles: "Añade al menos {n} archivos para continuar.",
    resultReady: "El resultado está listo",
    resultFiles: "{n} archivos generados",
    sizeChange: "{before} → {after}",
    reduced: "{percent} más pequeño",
    elapsed: "Tiempo: {seconds} s",
    yes: "Sí",
    no: "No",
    color: "Color",
    fontSize: "Tamaño de letra",
    opacity: "Opacidad",
    position: "Posición",
    margin: "Margen",
    none: "Ninguno",
    small: "Pequeño",
    medium: "Mediano",
    large: "Grande",
    reset: "Restablecer",
    retry: "Reintentar",
    readMore: "Más información",
    new: "Nuevo",
  },
  positions: {
    topLeft: "Arriba a la izquierda",
    topCenter: "Arriba en el centro",
    topRight: "Arriba a la derecha",
    middleLeft: "En medio a la izquierda",
    center: "En el centro",
    middleRight: "En medio a la derecha",
    bottomLeft: "Abajo a la izquierda",
    bottomCenter: "Abajo en el centro",
    bottomRight: "Abajo a la derecha",
  },
  errors: {
    title: "No se ha podido completar",
    generic: "Se ha producido un error inesperado: {message}",
    invalidPdf: "«{name}» no parece un PDF válido o está dañado. Prueba la herramienta Reparar PDF.",
    invalidImage: "No se ha podido leer la imagen «{name}».",
    wrongPassword: "La contraseña no es correcta.",
    outOfMemory: "El dispositivo se ha quedado sin memoria. Prueba con menos páginas, una resolución más baja u otro navegador.",
    engineDownload: "No se ha podido descargar el motor necesario. Comprueba la conexión y vuelve a intentarlo.",
    noText: "Este PDF no contiene texto seleccionable (parece escaneado). Prueba antes la herramienta OCR.",
    noPagesSelected: "Selecciona al menos una página.",
    allPagesDeleted: "No puedes eliminar todas las páginas del documento.",
    invalidRange: "El intervalo «{range}» no es válido para un documento de {total} páginas.",
    encryptedSkipped: "Se ha omitido «{name}» porque está protegido con contraseña.",
    noFiles: "Todavía no has añadido ningún archivo.",
    browserUnsupported: "Tu navegador no es compatible con esta función. Usa una versión reciente de Chrome, Edge, Firefox o Safari.",
  },
  password: {
    title: "PDF protegido con contraseña",
    text: "«{name}» está protegido. Escribe la contraseña para abrirlo. Se descifra solo en este dispositivo.",
    label: "Contraseña",
    submit: "Abrir",
    skip: "Omitir este archivo",
    show: "Mostrar la contraseña",
  },
  engines: {
    ocrName: "Motor de OCR (Tesseract)",
    officeName: "Motor de documentos (LibreOffice)",
    gsName: "Motor Ghostscript (compresión y PDF/A)",
    mupdfName: "Motor MuPDF (censura de datos)",
    needDownloadTitle: "Hay que descargar un motor adicional",
    needDownloadText:
      "Esta herramienta usa {engine}, que ocupa unos {size}. Se descarga una sola vez desde esta misma web y se guarda en el navegador para que funcione sin conexión. Tus documentos siguen sin salir del dispositivo.",
    download: "Descargar y continuar",
    downloading: "Descargando {engine}… {percent}",
    starting: "Iniciando {engine}… La primera vez puede tardar hasta un minuto.",
    available: "Disponible sin conexión",
    notDownloaded: "No descargado",
  },
  offline: {
    online: "En línea",
    offline: "Sin conexión: las herramientas siguen funcionando",
    offlineShort: "Sin conexión",
    ready: "Listo para funcionar sin conexión",
    updateReady: "Hay una nueva versión disponible.",
    reload: "Actualizar",
    panelTitle: "Uso sin conexión",
    panelText: "La aplicación ya se guarda en el navegador. Puedes descargar ahora los motores opcionales para tenerlo todo disponible sin conexión:",
    prepare: "Descargar",
    remove: "Borrar",
    unsupported: "Este navegador no permite guardar la aplicación para usarla sin conexión.",
    storage: "Espacio usado: {used}",
  },
  footer: {
    resourceBy: "Un recurso gratuito de",
    about:
      "NetSereno es un servicio de ciberseguridad inspirado en los serenos: vigilamos tu presencia digital, detectamos filtraciones en la dark web y formamos equipos contra el phishing.",
    toolsTitle: "Herramientas más usadas",
    infoTitle: "Información",
    privacy: "Cómo protegemos tu privacidad",
    licenses: "Licencias de código abierto",
    netsereno: "NetSereno.com",
    resources: "Recursos gratuitos de NetSereno",
    source: "Código fuente (AGPL)",
    rights: "© {year} NetSereno. Todos los derechos reservados.",
    noCookies: "Sin cookies, sin analítica, sin subidas.",
  },
  tools: {
    merge: {
      name: "Unir PDF",
      description: "Combina varios PDF e imágenes en un solo documento, en el orden que quieras.",
      metaTitle: "Unir PDF gratis y sin subir archivos",
      metaDescription: "Une varios archivos PDF en uno solo directamente en el navegador. Ordénalos arrastrando. Gratis, privado y sin registro.",
      action: "Unir los PDF",
      hint: "Arrastra los archivos para cambiar el orden.",
      blankForDuplex: "Añadir una página en blanco tras los documentos con páginas impares (para imprimir a doble cara)",
      suffix: "unido",
    },
    split: {
      name: "Dividir PDF",
      description: "Separa un PDF en varios archivos por intervalos, cada N páginas o página a página.",
      metaTitle: "Dividir PDF en varios archivos, gratis y privado",
      metaDescription: "Divide un PDF por intervalos de páginas o en archivos individuales sin subirlo a Internet. Gratis y sin registro.",
      action: "Dividir el PDF",
      mode: "Modo",
      modeRanges: "Por intervalos",
      modeEvery: "Cada N páginas",
      modeAll: "Una página por archivo",
      ranges: "Intervalos (un archivo por intervalo)",
      rangesHint: "Ej.: 1-3, 4-6, 7-",
      every: "Páginas por archivo",
      suffix: "parte",
    },
    extract: {
      name: "Extraer páginas",
      description: "Crea un PDF nuevo solo con las páginas que elijas.",
      metaTitle: "Extraer páginas de un PDF gratis y privado",
      metaDescription: "Selecciona visualmente las páginas de un PDF y guárdalas en un documento nuevo. Sin subir archivos.",
      action: "Extraer las páginas",
      hint: "Haz clic en las páginas que quieres conservar.",
      separate: "Guardar cada página en un archivo separado",
      suffix: "extracto",
    },
    delete: {
      name: "Eliminar páginas",
      description: "Borra las páginas que no quieras de un PDF.",
      metaTitle: "Eliminar páginas de un PDF gratis y privado",
      metaDescription: "Elimina páginas de un PDF haciendo clic en las miniaturas. Gratis, sin registro y sin subir el archivo.",
      action: "Eliminar las páginas",
      hint: "Haz clic en las páginas que quieres eliminar.",
      suffix: "editado",
    },
    organize: {
      name: "Organizar PDF",
      description: "Reordena, gira, duplica, elimina y añade páginas con una vista de miniaturas.",
      metaTitle: "Organizar páginas de un PDF: reordenar, rotar y eliminar",
      metaDescription: "Arrastra las páginas para reordenarlas, gíralas, duplícalas o elimínalas. Combina páginas de varios PDF. Todo en tu navegador.",
      action: "Guardar el PDF",
      hint: "Arrastra las miniaturas para reordenar. Usa los botones de cada página para girarla, duplicarla o eliminarla.",
      addBlank: "Página en blanco",
      addFiles: "Añadir archivos",
      reverse: "Invertir el orden",
      rotateLeft: "Girar a la izquierda",
      rotateRight: "Girar a la derecha",
      duplicate: "Duplicar",
      blankPage: "En blanco",
      suffix: "organizado",
    },
    rotate: {
      name: "Rotar PDF",
      description: "Gira todas las páginas o solo las que elijas.",
      metaTitle: "Rotar PDF gratis: gira páginas sin subir archivos",
      metaDescription: "Gira las páginas de un PDF 90° o 180°, todas o algunas. Gratis, privado y en tu navegador.",
      action: "Aplicar la rotación",
      hint: "Usa los botones de cada página o gíralas todas a la vez.",
      allLeft: "Girar todas a la izquierda",
      allRight: "Girar todas a la derecha",
      suffix: "rotado",
    },
    compress: {
      name: "Comprimir PDF",
      description: "Reduce el tamaño de los PDF para enviarlos por correo o subirlos a portales.",
      metaTitle: "Comprimir PDF gratis sin subir el archivo",
      metaDescription: "Reduce el peso de tus PDF optimizando imágenes y estructura, directamente en el navegador. Privado, gratis y sin límites.",
      action: "Comprimir",
      level: "Nivel de compresión",
      lossless: "Sin pérdida",
      losslessDesc: "Optimiza la estructura interna sin tocar la calidad.",
      recommended: "Recomendada",
      recommendedDesc: "Buen equilibrio entre tamaño y calidad (imágenes a unos 150 ppp).",
      strong: "Máxima",
      strongDesc: "El tamaño más pequeño (imágenes a unos 100 ppp). Las fotos pierden calidad.",
      noGain: "«{name}» ya estaba optimizado: se ha conservado el original.",
      grayscale: "Convertir a escala de grises",
      grayscaleHint: "Quita el color de textos e imágenes: ideal para imprimir y reduce todavía más el tamaño.",
      grayForms: "«{name}» tiene campos de formulario: no se ha convertido a escala de grises para no perderlos.",
      grayFailed: "No se ha podido convertir «{name}» a escala de grises; se ha comprimido en color.",
      suffix: "comprimido",
    },
    repair: {
      name: "Reparar PDF",
      description: "Recupera PDF dañados o que no se abren correctamente.",
      metaTitle: "Reparar PDF dañados gratis y en privado",
      metaDescription: "Reconstruye la estructura de archivos PDF dañados directamente en el navegador, sin subirlos.",
      action: "Reparar",
      note: "Reconstruye la tabla de objetos y la estructura interna. No puede recuperar contenido que se haya perdido por completo.",
      suffix: "reparado",
    },
    ocr: {
      name: "OCR: PDF con texto",
      description: "Reconoce el texto de PDF escaneados e imágenes para que se pueda buscar y copiar.",
      metaTitle: "OCR en castellano, catalán y gallego: PDF escaneado a texto",
      metaDescription: "Convierte PDF escaneados e imágenes en PDF con texto buscable o en texto plano. Reconocimiento óptico de caracteres en tu navegador, sin subir archivos.",
      action: "Aplicar OCR",
      languages: "Idiomas del documento",
      output: "Resultado",
      outputPdf: "PDF con texto buscable",
      outputTxt: "Texto (.txt)",
      outputBoth: "Ambos",
      skipText: "Omitir las páginas que ya tienen texto",
      resolution: "Calidad",
      resolutionNormal: "Normal (200 ppp)",
      resolutionHigh: "Alta (300 ppp, más lenta)",
      progress: "Reconociendo la página {page} de {total}…",
      langCa: "Catalán",
      langEs: "Castellano",
      langGl: "Gallego",
      langEn: "Inglés",
      pickLanguage: "Elige al menos un idioma.",
      suffix: "ocr",
    },
    imagesToPdf: {
      name: "JPG a PDF",
      description: "Convierte fotos e imágenes (JPG, PNG, WebP…) en un PDF.",
      metaTitle: "Convertir JPG a PDF gratis y sin subir fotos",
      metaDescription: "Convierte imágenes JPG, PNG o WebP en PDF directamente en el navegador. Elige el tamaño de página y el orden. Privado y gratuito.",
      action: "Convertir a PDF",
      pageSize: "Tamaño de página",
      sizeA4: "A4",
      sizeLetter: "Carta",
      sizeFit: "Igual que la imagen",
      orientation: "Orientación",
      orientationAuto: "Automática",
      portrait: "Vertical",
      landscape: "Horizontal",
      separate: "Crear un PDF por cada imagen",
      suffix: "imagenes",
    },
    wordToPdf: {
      name: "Word a PDF",
      description: "Convierte documentos de Word, LibreOffice Writer o RTF a PDF.",
      metaTitle: "Convertir Word a PDF gratis y sin subir el documento",
      metaDescription: "Convierte DOC, DOCX, ODT y RTF a PDF con LibreOffice ejecutado en tu navegador. Sin subir archivos.",
      action: "Convertir a PDF",
      note: "La conversión la hace LibreOffice dentro de tu navegador. Si el documento usa fuentes poco habituales, el resultado puede variar ligeramente.",
    },
    excelToPdf: {
      name: "Excel a PDF",
      description: "Convierte hojas de cálculo de Excel, LibreOffice Calc o CSV a PDF.",
      metaTitle: "Convertir Excel a PDF gratis y en privado",
      metaDescription: "Convierte XLS, XLSX, ODS y CSV a PDF con LibreOffice en tu navegador. Sin subir archivos.",
      action: "Convertir a PDF",
      note: "Se usa el área de impresión y la configuración de página de la hoja de cálculo.",
    },
    pptToPdf: {
      name: "PowerPoint a PDF",
      description: "Convierte presentaciones de PowerPoint o LibreOffice Impress a PDF.",
      metaTitle: "Convertir PowerPoint a PDF gratis y en privado",
      metaDescription: "Convierte PPT, PPTX y ODP a PDF con LibreOffice en tu navegador. Sin subir archivos.",
      action: "Convertir a PDF",
      note: "Cada diapositiva se convierte en una página. Las animaciones no se conservan.",
    },
    pdfToImages: {
      name: "PDF a JPG",
      description: "Guarda cada página de un PDF como imagen JPG o PNG.",
      metaTitle: "Convertir PDF a JPG o PNG gratis y en privado",
      metaDescription: "Convierte las páginas de un PDF en imágenes JPG o PNG de alta calidad directamente en el navegador.",
      action: "Convertir a imágenes",
      format: "Formato",
      resolution: "Resolución",
      dpiLow: "72 ppp (pantalla)",
      dpiMedium: "150 ppp (recomendada)",
      dpiHigh: "300 ppp (impresión)",
    },
    pdfToText: {
      name: "PDF a texto",
      description: "Extrae todo el texto de un PDF en un archivo .txt.",
      metaTitle: "Extraer el texto de un PDF gratis y en privado",
      metaDescription: "Copia todo el texto de un PDF en un archivo de texto plano, en tu navegador y sin subir el documento.",
      action: "Extraer el texto",
      separators: "Marcar el inicio de cada página",
      pageHeader: "--- Página {n} ---",
    },
    pdfToWord: {
      name: "PDF a Word",
      description: "Convierte el texto de un PDF en un documento Word (DOCX) editable.",
      metaTitle: "Convertir PDF a Word (DOCX) gratis y en privado",
      metaDescription: "Convierte un PDF en un documento DOCX editable con los párrafos originales, sin subirlo a Internet.",
      action: "Convertir a Word",
      note: "Se conservan el texto, los párrafos y los saltos de página. Las tablas, las imágenes y los diseños complejos no se reproducen. Para PDF escaneados, aplica antes el OCR.",
    },
    pdfa: {
      name: "PDF a PDF/A",
      description: "Convierte un PDF al formato de archivo a largo plazo PDF/A, exigido por muchas administraciones.",
      metaTitle: "Convertir PDF a PDF/A gratis y sin subir el archivo",
      metaDescription: "Convierte PDF a PDF/A-1b, PDF/A-2b o PDF/A-3b para archivarlos o presentarlos en una sede electrónica, en tu navegador. Privado y gratuito.",
      action: "Convertir a PDF/A",
      level: "Versión de PDF/A",
      pdfa2: "PDF/A-2b (recomendada)",
      pdfa2Desc: "La más aceptada: admite transparencias y capas.",
      pdfa1: "PDF/A-1b",
      pdfa1Desc: "Para sistemas antiguos que solo aceptan PDF/A-1.",
      pdfa3: "PDF/A-3b",
      pdfa3Desc: "Como la 2b, pero permite adjuntar archivos de cualquier tipo.",
      note: "Las fuentes se incrustan, los colores se convierten a sRGB y se eliminan los elementos que el formato no admite (JavaScript, contenido externo…). Los formularios se convierten en contenido fijo. Si necesitas acreditar la conformidad, valida el resultado con veraPDF.",
      removed: "Algunos elementos de «{name}» no eran compatibles con PDF/A y se han eliminado.",
      suffix: "pdfa",
    },
    sign: {
      name: "Firmar PDF",
      description: "Añade tu firma manuscrita, la fecha o texto en cualquier página.",
      metaTitle: "Firmar PDF gratis: añade tu firma sin subir el documento",
      metaDescription: "Dibuja, escribe o sube tu firma y colócala en el PDF. Todo se hace en tu navegador, sin registro.",
      action: "Guardar el PDF firmado",
      create: "Crear la firma",
      edit: "Cambiar la firma",
      tabDraw: "Dibujar",
      tabType: "Escribir",
      tabUpload: "Imagen",
      drawHint: "Firma con el ratón, el dedo o un lápiz.",
      clear: "Borrar",
      typePlaceholder: "Escribe tu nombre",
      uploadHint: "Sube una foto o un escaneo de tu firma.",
      removeBackground: "Hacer transparente el fondo blanco",
      useSignature: "Usar esta firma",
      addSignature: "Añadir la firma",
      addDate: "Añadir la fecha",
      addText: "Añadir texto",
      textPrompt: "Texto que quieres añadir",
      placeHint: "Arrastra los elementos para moverlos y usa la esquina para cambiar el tamaño.",
      applyAll: "Repetir en todas las páginas",
      removeItem: "Eliminar el elemento",
      prevPage: "Página anterior",
      nextPage: "Página siguiente",
      noItems: "Añade al menos una firma o un texto.",
      disclaimer: "Es una firma manuscrita (imagen), no una firma electrónica cualificada con certificado digital.",
      suffix: "firmado",
    },
    pageNumbers: {
      name: "Numerar páginas",
      description: "Añade números de página con la posición y el formato que quieras.",
      metaTitle: "Añadir números de página a un PDF gratis",
      metaDescription: "Numera las páginas de un PDF eligiendo posición, formato y primera página, directamente en el navegador.",
      action: "Numerar las páginas",
      format: "Formato",
      formatN: "1",
      formatNOfTotal: "1 / 10",
      formatPage: "Página 1 de 10",
      pageWord: "Página {n} de {total}",
      startNumber: "Primer número",
      fromPage: "Empezar en la página",
      suffix: "numerado",
    },
    watermark: {
      name: "Marca de agua",
      description: "Estampa un texto o una imagen (CONFIDENCIAL, BORRADOR, tu logotipo…).",
      metaTitle: "Añadir marca de agua a un PDF gratis y en privado",
      metaDescription: "Añade una marca de agua de texto o imagen a tus PDF, con opacidad y rotación configurables, sin subirlos.",
      action: "Añadir la marca de agua",
      type: "Tipo",
      typeText: "Texto",
      typeImage: "Imagen",
      text: "Texto",
      defaultText: "CONFIDENCIAL",
      image: "Imagen (PNG o JPG)",
      chooseImage: "Elige una imagen",
      imageScale: "Tamaño (% del ancho de página)",
      rotation: "Rotación",
      layout: "Distribución",
      layoutCenter: "Una en el centro",
      layoutTile: "Mosaico",
      noImage: "Elige una imagen para la marca de agua.",
      suffix: "marca",
    },
    flatten: {
      name: "Aplanar PDF",
      description: "Convierte los formularios rellenados en contenido fijo que ya no se puede modificar.",
      metaTitle: "Aplanar formularios PDF gratis y en privado",
      metaDescription: "Aplana los campos de formulario de un PDF para que no se puedan editar, directamente en el navegador.",
      action: "Aplanar",
      note: "Los valores de los campos se conservan, pero dejan de ser editables.",
      noFields: "«{name}» no tiene campos de formulario; se ha guardado igualmente.",
      suffix: "aplanado",
    },
    metadata: {
      name: "Metadatos",
      description: "Consulta, edita o elimina el autor, el software y otros datos ocultos.",
      metaTitle: "Ver, editar y eliminar metadatos de PDF",
      metaDescription: "Elimina los metadatos ocultos de un PDF (autor, software, fechas) antes de compartirlo, o edítalos. Sin subir el archivo.",
      action: "Guardar",
      mode: "¿Qué quieres hacer?",
      modeEdit: "Editar los metadatos",
      modeStrip: "Eliminarlos todos (recomendado antes de compartir)",
      stripNote: "Se eliminarán el título, el autor, el software, las fechas, los identificadores y los metadatos XMP.",
      title: "Título",
      author: "Autor",
      subject: "Asunto",
      keywords: "Palabras clave",
      creator: "Aplicación de creación",
      producer: "Productor",
      creationDate: "Fecha de creación",
      modDate: "Fecha de modificación",
      current: "Metadatos actuales",
      empty: "(vacío)",
      suffix: "metadatos",
    },
    protect: {
      name: "Proteger PDF",
      description: "Cifra un PDF con contraseña (AES-256) y limita su impresión o copia.",
      metaTitle: "Proteger PDF con contraseña gratis (AES-256)",
      metaDescription: "Pon contraseña a un PDF con cifrado AES-256 y elige los permisos, directamente en el navegador.",
      action: "Proteger el PDF",
      password: "Contraseña para abrir",
      confirm: "Repite la contraseña",
      mismatch: "Las contraseñas no coinciden.",
      empty: "Escribe una contraseña.",
      permissions: "Permisos",
      allowPrint: "Permitir imprimir",
      allowCopy: "Permitir copiar texto e imágenes",
      allowModify: "Permitir modificar el documento",
      allowAnnotate: "Permitir comentarios y rellenar formularios",
      note: "Cifrado AES-256. Si olvidas la contraseña, no hay forma de recuperarla.",
      suffix: "protegido",
    },
    unlock: {
      name: "Desbloquear PDF",
      description: "Quita la contraseña de un PDF del que conoces la contraseña.",
      metaTitle: "Quitar la contraseña de un PDF gratis y en privado",
      metaDescription: "Elimina la contraseña y las restricciones de un PDF cuando conoces la clave. Todo se hace en tu navegador.",
      action: "Desbloquear",
      note: "Necesitas conocer la contraseña: esta herramienta no rompe contraseñas. Si el PDF solo tenía restricciones de impresión o copia, se eliminan.",
      notEncrypted: "«{name}» no estaba protegido; se ha guardado sin cambios.",
      suffix: "desbloqueado",
    },
    redact: {
      name: "Censurar PDF",
      description: "Elimina de verdad datos personales o cualquier zona de un PDF, y detecta DNI, correos, teléfonos e IBAN.",
      metaTitle: "Censurar PDF gratis: elimina datos personales sin subir el documento",
      metaDescription: "Tacha en negro y elimina de verdad DNI, correos, teléfonos, IBAN o cualquier zona de un PDF. Se hace en tu navegador, sin subir el archivo.",
      action: "Aplicar la censura",
      hint: "Arrastra sobre la página para marcar una zona, o usa la búsqueda y la detección automática. Haz clic en la cruz de una zona para desmarcarla.",
      area: "Zona marcada",
      searchLabel: "Buscar un texto",
      searchPlaceholder: "Nombre, dirección, número…",
      searchButton: "Marcar las coincidencias",
      detectTitle: "Detección automática",
      detectId: "DNI y NIE",
      detectEmail: "Direcciones de correo",
      detectPhone: "Teléfonos",
      detectIban: "Cuentas bancarias (IBAN)",
      detectButton: "Detectar y marcar",
      found: "Se han marcado {n} coincidencias nuevas.",
      notFound: "No se ha encontrado ninguna coincidencia. Si el PDF está escaneado, marca las zonas a mano o aplícale antes el OCR.",
      marked: "Zonas marcadas: {n}",
      onPage: "{n} en esta página",
      clearAll: "Desmarcar todo",
      removeMark: "Desmarcar la zona",
      prevPage: "Página anterior",
      nextPage: "Página siguiente",
      stripMetadata: "Eliminar también los metadatos (autor, título, programa…)",
      note: "La censura es definitiva: el texto, las imágenes, los trazos, los campos de formulario y los comentarios que quedan bajo las zonas se eliminan del archivo, no solo se tapan. Revisa todas las páginas antes de guardar.",
      noMarks: "Marca al menos una zona para censurar.",
      leftovers: "Atención: «{text}» todavía aparece en el documento fuera de las zonas marcadas. Revísalo antes de compartirlo.",
      suffix: "censurado",
    },
  },
  pages: {
    privacy: {
      title: "Cómo protegemos tu privacidad",
      metaDescription: "Explicación técnica de por qué NetSereno PDF no puede ver tus documentos y cómo puedes comprobarlo tú mismo.",
      intro:
        "NetSereno PDF es una aplicación web que se ejecuta por completo en tu navegador. Nuestro servidor solo envía los archivos de la aplicación (HTML, JavaScript y WebAssembly). Tus documentos nunca llegan a él.",
      sections: [
        {
          title: "Qué pasa cuando abres un archivo",
          text: "El navegador lee el archivo en la memoria RAM de tu dispositivo. Las bibliotecas de procesamiento (pdf-lib, PDF.js, Tesseract, qpdf, Ghostscript, MuPDF y LibreOffice compiladas a WebAssembly) trabajan sobre esa copia local y generan el resultado también en local. Al cerrar o recargar la pestaña, la memoria se libera.",
        },
        {
          title: "Qué no hacemos",
          text: "No subimos archivos, no usamos cookies, no tenemos analítica de visitantes, no cargamos scripts ni fuentes de terceros y no pedimos ningún registro. No guardamos tus documentos en el navegador: solo guardamos la aplicación para que funcione sin conexión.",
        },
        {
          title: "Cómo puedes comprobarlo",
          text: "1) Abre las herramientas de desarrollo del navegador (F12), ve a la pestaña Red y procesa un archivo: no verás ninguna subida. 2) Activa el modo avión después de cargar la página: todas las herramientas siguen funcionando. 3) Revisa la cabecera Content-Security-Policy del sitio: la directiva connect-src 'self' impide que el código envíe datos a cualquier otro servidor.",
        },
        {
          title: "Registros del servidor",
          text: "Como cualquier web, el servidor que aloja la aplicación registra las peticiones de archivos estáticos (dirección IP, página y hora) por motivos de seguridad y operación. Estos registros nunca contienen información de tus documentos.",
        },
        {
          title: "Código abierto",
          text: "El código fuente de la aplicación es público y libre (licencia AGPL-3.0): cualquier persona puede comprobar que hace lo que dice. Se basa en bibliotecas de código abierto reconocidas, que puedes consultar en la página de licencias.",
        },
      ],
    },
    licenses: {
      title: "Licencias de código abierto",
      metaDescription: "Componentes de código abierto que usa NetSereno PDF y sus licencias.",
      intro: "NetSereno PDF es posible gracias a estos proyectos de código abierto. Gracias a todas las personas que contribuyen a ellos.",
      component: "Componente",
      license: "Licencia",
      usage: "Uso",
      appTitle: "Licencia de NetSereno PDF",
      appText: "NetSereno PDF es software libre: puedes usarlo, estudiarlo, modificarlo y redistribuirlo según los términos de la GNU Affero General Public License, versión 3 o posterior. Incluye Ghostscript y MuPDF, de Artifex Software, que se distribuyen con la misma licencia.",
      sourceLink: "Consultar el código fuente",
    },
    notFound: {
      title: "Página no encontrada",
      text: "La página que buscas no existe o se ha movido.",
      back: "Volver al inicio",
    },
  },
};
